import { useEffect } from 'react'
import { toastStore } from 'shared/ui'
import { WebsocketEvent } from 'entities/WebSocket/store'
import { type IResponseCallTransferFailed } from 'entities/Call/api/types'
import { useEntitiesContext } from 'entities/EntitiesExport'
import {
  getTransferFailureDescription,
  getTransferTargetName,
} from 'entities/Call/lib/transferTarget'

export const useEventCallTransferFailed = () => {
  const { websocket, inboxesStore, callStore } = useEntitiesContext()

  const handle = (data: IResponseCallTransferFailed) => {
    if (!callStore.isOwnTransferLeg(data.agent_call_sid)) return

    callStore.setTransferringCallSid(null)

    const target = getTransferTargetName(data, inboxesStore)

    toastStore.add({
      type: 'error',
      title: `Transfer to ${target} failed`,
      desc: getTransferFailureDescription(data.reason),
    })
  }

  useEffect(() => websocket.on(WebsocketEvent.CallCallTransferFailed, handle), [callStore])
}
